import { forwardRef, ReactNode } from "react";

import { styled } from "styled-components";

import { RadioButton, RadioButtonProps } from "./RadioButton";

const LabelRow = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  gap: 12px;

  input[type="radio"] {
    flex-shrink: 0;
  }
`;

const Group = styled.fieldset`
  border: none;
  margin: 0;
  padding: 0;
`;

export interface RadioGroupOptionProps extends RadioButtonProps {
  labelText: ReactNode;
}

export const RadioGroupOption = forwardRef<
  HTMLInputElement,
  RadioGroupOptionProps
>(({ labelText, ...radioProps }, ref) => (
  <LabelRow>
    {labelText}
    <RadioButton ref={ref} {...radioProps} />
  </LabelRow>
));

type RadioGroupProps = React.PropsWithChildren;

export const RadioGroup = forwardRef<HTMLFieldSetElement, RadioGroupProps>(
  ({ children }, ref) => {
    return (
      <Group role="radiogroup" ref={ref}>
        {children}
      </Group>
    );
  },
);
